import 'bootstrap-select';
import 'bootstrap-select/sass/bootstrap-select.scss';

import { Amplitude } from '../Shared/amplitude';
import { Navigation } from '../Shared/navigation';

import './portfolio';
import './portfolio-landing';
import './investor-dashboard';
import './provider-dashboard';

import './partner-dashboard';
import './project';
import './inbox';

import '../Shared/person-logo';

import '../../Styles/Home/home.scss';

const onLoad = () => {
	$('#role').selectpicker();

	$('#role').change((e) => {
		const url = (e.target as HTMLInputElement).value;
		Navigation.visit(url);
	});

	$('.deal-card').click(function () {
		Amplitude.logEvent('Deal Card - Open', {
			'Project': $('#project-name').val()
		});
	});
}

$(() => {
	onLoad();
	document.addEventListener('turbolinks:load', onLoad);
});
